import React, {Component} from 'react';
import style from './style.module.scss';
import {Button, Theme, useTheme, withStyles} from '@material-ui/core';
import {IHandlers, IProps} from './types';
import { renderIf } from 'app/services/reactUtils.service';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Check from '@material-ui/icons/Check';
import classNames from 'classnames';
import CircularProgress from "@material-ui/core/CircularProgress";

const NS = 'NewBookingNav';

export default function NewBookingNav(
  {
    backLabel, backHandler,
    nextLabel, nextHandler, nextDisabled,
    saveHandler, showSave, canSave, isLoading, isSaving
  }: IProps & IHandlers) {

  const theme: Theme = useTheme();

  const SaveButton = withStyles({
    root: {
      color: canSave ? '#fff' : theme.palette.primary.main
    }
  })(Button);

  const NextButton = withStyles({
    root: {
      color: nextDisabled ? 'rgba(0, 0, 0, 0.26)' : theme.palette.primary.main
    }
  })(Button);

  return (
    <div className={style.root} >
      {renderIf(isLoading, () => (
        <CircularProgress size={20} className={style.nextLoader} />
      ))}
      {renderIf(backLabel, () => (
        <Button
          variant="text"
          onClick={() => backHandler()}
          startIcon={<ArrowBack />}
          data-testid="previous-button"
        >
          {backLabel}
        </Button>
      ), () => (
        <div>
          {/* placeholder back button for layout */}
        </div>
      ))}

      {renderIf(nextLabel, () => (
        <NextButton
          variant="text"
          onClick={() => nextHandler()}
          endIcon={
            <ArrowForward className={classNames({
              [style.notValid]: nextDisabled
            })} />
          }
          data-testid="next-button"
        >
          {nextLabel}
        </NextButton>
      ))}

      {renderIf(showSave, () => (
        <SaveButton
          className={classNames({
            [style.notValid]: !canSave
          })}
          variant="contained"
          color="primary"
          disabled={isSaving}
          onClick={() => {
            saveHandler();
          }}
          startIcon={
            <Check className={classNames({
              [style.notValid]: nextDisabled
            })} />
          }
          data-testid="save-button"
        >
          Save
        </SaveButton>
      ))}
    </div>
  );
}
